import * as React from "react";

interface DockContextValue {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

const DockContext = React.createContext<DockContextValue | null>(null);

interface DockProviderProps {
  children: React.ReactNode;
  initialOpen?: boolean;
}

export function DockProvider({ children, initialOpen = false }: DockProviderProps) {
  const [open, setOpen] = React.useState(initialOpen);

  const value = React.useMemo<DockContextValue>(
    () => ({
      open,
      setOpen,
      toggle: () => setOpen((cur) => !cur),
    }),
    [open],
  );

  return <DockContext.Provider value={value}>{children}</DockContext.Provider>;
}

/**
 * Hook to read or control the right command-bar dock visibility.
 * Components outside the RightCommandBar (e.g. the dev console placeholder)
 * use this to imperatively open the dock.
 */
export function useDock(): DockContextValue {
  const ctx = React.useContext(DockContext);
  if (!ctx) {
    throw new Error("useDock must be used inside <DockProvider>");
  }
  return ctx;
}
